import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { FocusedScreen } from "../types";

export const initialState: FocusedScreen = {
  streamId: null,
  theaterId: null,
  userId: null,
  publisherName: null,
};

const broadcastFocusScreenSlice = createSlice({
  name: "broadcastFocusScreen",
  initialState,
  reducers: {
    updateFocusScreen: (
      state: FocusedScreen,
      action: PayloadAction<Partial<FocusedScreen>>,
    ) => ({
      ...state,
      ...action.payload,
    }),
    resetState: () => initialState,
  },
});

export const { updateFocusScreen, resetState } =
  broadcastFocusScreenSlice.actions;

export default broadcastFocusScreenSlice.reducer;
